import React from 'react';
import StaffScanGate from '@/components/StaffScanGate';
import SectionBundleReceiptEntry from '../SectionBundleReceiptEntry';

const TissueBundleReceiptEntry = () => {
  return (
    <StaffScanGate stationName="Tissue — Bundle Receipt">
    <SectionBundleReceiptEntry
      sectionName="Tissue"
      sectionDisplayName="Tissue Section"
      backRoute="/sections/tissue"
    />
    </StaffScanGate>
  );
};

export default TissueBundleReceiptEntry;
